var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.781 10.531-4 4c-.312.313-.781.313-1.062 0-.313-.281-.313-.75 0-1.062l2.719-2.719H7.75A.722.722 0 0 1 7 10a.74.74 0 0 1 .75-.75h7.688l-2.72-2.719c-.312-.281-.312-.75 0-1.062.282-.282.75-.282 1.063 0l4 4.031a.736.736 0 0 1 0 1.031zM7.25 4.5h-2.5c-.719 0-1.25.563-1.25 1.25v8.5c0 .719.531 1.25 1.25 1.25h2.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75h-2.5A2.734 2.734 0 0 1 2 14.25v-8.5C2 4.25 3.219 3 4.75 3h2.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/SignOutIcon.a52e7131fed9f2d834d675e75886a75e.svg";
export { ForwardRef as ReactComponent };